import React from 'react';
import PropTypes from 'prop-types';
import { DateTime } from 'luxon';
import { useClassName } from 'common/hooks';
import { formatOpeningHoursForDate } from 'utils/helpers/openingHours';

import CharacterAppearances from '../CharacterAppearances';
import TemporaryClosures from '../TemporaryClosures';
import { useCharacterAppearances } from '../useCharacterAppearances';
import { getClosuresForDate } from '../utils';

import './date-schedule-panel.less';

const DateSchedulePanel = ({
  venueId,
  ridesCards,
  openingHours,
  date,
  characterAppearancesTitle,
  showAdditionalDetails,
}) => {
  const classNames = useClassName('DateSchedulePanel');
  const iso = date ? DateTime.fromJSDate(date).toISODate() : null;
  const appearances = useCharacterAppearances(
    showAdditionalDetails ? venueId : null,
    showAdditionalDetails ? iso : null
  );
  const closedInfo = showAdditionalDetails
    ? getClosuresForDate(ridesCards, date)
    : null;
  // One bullet line per closed ride → real count for the toggle title.
  const closuresCount = closedInfo ? closedInfo.message.split('\n').length : 0;

  if (!date) return null;

  return (
    <div className={classNames('container')}>
      <p className={classNames('date')}>
        {DateTime.fromJSDate(date).toFormat('EEEE, MMMM dd, yyyy')}
      </p>
      {openingHours && (
        <p className={classNames('time')}>
          {formatOpeningHoursForDate(openingHours, date)}
        </p>
      )}
      {showAdditionalDetails && (
        <>
          <CharacterAppearances
            appearances={appearances}
            title={characterAppearancesTitle}
          />
          <TemporaryClosures
            closedInfo={closedInfo}
            title={`${closuresCount} Temporary closure${
              closuresCount === 1 ? '' : 's'
            } on this date`}
          />
        </>
      )}
    </div>
  );
};

DateSchedulePanel.propTypes = {
  venueId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ridesCards: PropTypes.array,
  openingHours: PropTypes.object,
  date: PropTypes.instanceOf(Date),
  characterAppearancesTitle: PropTypes.string,
  showAdditionalDetails: PropTypes.bool,
};

DateSchedulePanel.defaultProps = {
  ridesCards: [],
  characterAppearancesTitle: 'Characters Appearances',
  showAdditionalDetails: true,
};

export default DateSchedulePanel;
